"use client";

import Link from "next/link";
import { useActionState } from "react";
import { login } from "@/app/actions/auth";
import { Button, ErrorBanner, Field, TagCard, Wordmark } from "@/components/ui";

export default function LoginPage() {
  const [state, formAction, pending] = useActionState(login, undefined);

  return (
    <main className="flex flex-1 flex-col items-center justify-center gap-8 px-6 py-24">
      <Wordmark />
      <div className="w-full max-w-sm">
        <TagCard>
          <h1 className="mb-6 font-mono text-lg font-semibold text-ink">Log in</h1>
          <form action={formAction} className="flex flex-col gap-4">
            <Field label="Email" name="email" type="email" required autoComplete="email" />
            <Field
              label="Password"
              name="password"
              type="password"
              required
              autoComplete="current-password"
            />
            {state?.error && <ErrorBanner>{state.error}</ErrorBanner>}
            <Button type="submit" disabled={pending} className="mt-2">
              {pending ? "Logging in…" : "Log in"}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-ink-muted">
            No account?{" "}
            <Link href="/signup" className="font-semibold text-moss hover:underline">
              Sign up
            </Link>
          </p>
        </TagCard>
      </div>
    </main>
  );
}
